import React, { createContext, useContext, useState, useCallback, useMemo, useEffect } from 'react';
import { getStoredLocale, setStoredLocale, t as tRaw } from '../i18n/translations';

const LocaleContext = createContext(null);

export function LocaleProvider({ children }) {
  const [locale, setLocaleState] = useState(() => getStoredLocale());

  useEffect(() => {
    const root = document.documentElement;
    root.lang = locale === 'ar' ? 'ar' : 'en';
    root.dir = locale === 'ar' ? 'rtl' : 'ltr';
    document.title = locale === 'ar' ? 'أوريون وحدة التحكم' : 'Orion Console';
  }, [locale]);

  const setLocale = useCallback((next) => {
    setLocaleState((prev) => {
      const value = typeof next === 'function' ? next(prev) : next;
      if (value !== 'en' && value !== 'ar') return prev;
      setStoredLocale(value);
      return value;
    });
  }, []);

  const dir = locale === 'ar' ? 'rtl' : 'ltr';
  const lang = locale === 'ar' ? 'ar' : 'en';
  const t = useCallback((key, params) => tRaw(locale, key, params), [locale]);

  const value = useMemo(
    () => ({ locale, setLocale, dir, lang, t }),
    [locale, setLocale, t, dir, lang]
  );

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

export function useLocale() {
  const ctx = useContext(LocaleContext);
  if (!ctx) throw new Error('useLocale must be used within LocaleProvider');
  return ctx;
}
